import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-rate-input',
  templateUrl: './fb-basic-input-rate-input.component.html',
  styleUrls: ['./fb-basic-input-rate-input.component.css']
})
export class FbCoreBasicInputRateInputComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

    get number(): number {
        return this.data.component.characterCount;
    }
    
    get commentBox(): boolean {
        return this.data.component.commentBox;
    }

    get commentLabel(): string {
        return this.data.component.commentLabel;
    }
}
